import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'reactstrap';
import ReactPaginate from 'react-paginate';
import { format } from 'date-fns';
import { ProductContext } from '../../../../store';
import ReportHeader from '../../../../components/Search/ReportHeader';
import ReportSortArrows from '../../../../components/Search/ReportSortArrows';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import TableSkeleton from '../../../../components/Skeleton/TableSkeleton';
import { PostData } from '../../../../services/FetchData';
import { buildReportRequestPayload, getActiveWebsiteId } from '../../../../utils/reportUtils';
import { searchReportsAnalyticsUrl } from '../../../../constants/searchReportsAnalyticsApi';
import { toast } from 'react-toastify';

const TopPerformingProducts = () => {
    const [pageLoader, setPageLoader] = useState(true),
        [tableLoader, setTableLoader] = useState(true),
        [data, setData] = useState([]),
        [totalPageCount, setTotalPageCount] = useState(0),
        [limit, setLimit] = useState(25),
        [page, setPage] = useState(0),
        [sortField, setSortField] = useState(null),
        [sortOrder, setSortOrder] = useState("desc"),
        { dateRange, setDateRange, currentWebsiteId } = useContext(ProductContext);

    useEffect(() => {
        if (getActiveWebsiteId(currentWebsiteId)) {
            getReports();
        }
    }, [dateRange, limit, page, currentWebsiteId, sortField, sortOrder]);

    const handleSort = (field, e) => {
        e?.stopPropagation?.();
        if (sortField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortField(field);
            setSortOrder("desc");
        }
        setPage(0);
    };
    const setSort = (field, order, e) => {
      e?.stopPropagation?.();
      setPage(0);
      setSortField(field);
      setSortOrder(order);
    };


    const getReports = () => {
        setTableLoader(true);
        const payload = buildReportRequestPayload(currentWebsiteId, dateRange, {
            page: page + 1,
            limit,
            sortField: sortField || "",
            sortOrder: sortOrder || "desc",
        });
        if (!payload) {
            setTableLoader(false);
            setPageLoader(false);
            return;
        }

        PostData("ms1", searchReportsAnalyticsUrl("topPerformingProduct"), payload).then(response => {
            if (response !== "Invalid" && response !== "undefined") {
                if (response.status === "success") {
                    const transformedData = response.data.data
                        // .filter(item => {
                        //     // Remove products where clicks, impressions, and addToCart are all zero
                        //     const clicks = item.clicks || 0;
                        //     const impressions = item.impressions || 0;
                        //     const addToCart = item.addToCart || 0;
                        //     return !(clicks === 0 && impressions === 0 && addToCart === 0);
                        // })
                        .map(item => {
                            const clicks = item.clicks || 0;
                            const impressions = item.impressions || 0;
                            const addToCart = item.addToCart || 0;
                            const conversions = item.conversions || 0;
                        
                            const ctr = impressions > 0 ? ((clicks / impressions) * 100).toFixed(2) : "0.00";
                        
                            // Conversion rate priority: clicks > impressions > addToCart
                            let conversionRate;
                            if (clicks > 0) {
                                conversionRate = ((conversions / clicks) * 100).toFixed(2);
                            } else if (impressions > 0) {
                                conversionRate = ((conversions / impressions) * 100).toFixed(2);
                            } else if (addToCart > 0) {
                                conversionRate = ((conversions / addToCart) * 100).toFixed(2);
                            } else {
                                conversionRate = "0.00";
                            }
                        
                            return {
                                ...item,
                                ctr: ctr + "%",
                                conversionRate: conversionRate + "%"
                            };
                        })
                        //.filter(item => item.conversionRate !== "0.00%");
                    
                    setData(transformedData);
                    
                    let totalRecord = response.data.total,
                        totalPage = Math.ceil(totalRecord / limit);
                    setTotalPageCount(totalPage);
                } else {
                    toast.error(response.message);
                }
            }
            setTableLoader(false);
            setPageLoader(false);
        }).catch(err => {
            console.error("Error fetching top performing products:", err);
            setTableLoader(false);
            setPageLoader(false);
        });
    };

    return (
        <div>
            {pageLoader ?
                <DetailSkeleton />
            :
                <React.Fragment>
                    <ReportHeader range={dateRange} onDateChange={(range) => setDateRange(range)} />
                    <div className="tab-content mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="mb-0">Top Performing Products</h4>
                            <div className="d-flex align-items-center">
                                <label htmlFor="limit" className="me-2">
                                    Items Per Page:
                                </label>
                                <select id="limit" className="form-select" value={limit} onChange={(e) => setLimit(Number(e.target.value))} style={{ width: "100px", fontSize: "12px" }}>
                                    <option value={25}>25</option>
                                    <option value={30}>30</option>
                                    <option value={50}>50</option>
                                    <option value={100}>100</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            {tableLoader ?
                                <TableSkeleton />
                            :
                                <Table className={`table ${data.length > 0 ? "table-striped" : ""} mt-3 custom-bordered-table`}>
                                    <thead>
                                        <tr>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("productname", e)}>
                                                <div className="sortable-header-inner">
                                                    Product Name
                                                    <ReportSortArrows field="productname" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("impressions", e)}>
                                                <div className="sortable-header-inner">
                                                    Impressions
                                                    <ReportSortArrows field="impressions" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("clicks", e)}>
                                                <div className="sortable-header-inner">
                                                    Clicks
                                                    <ReportSortArrows field="clicks" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("ctr", e)}>
                                                <div className="sortable-header-inner">
                                                    CTR %
                                                    <ReportSortArrows field="ctr" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("conversions", e)}>
                                                <div className="sortable-header-inner">
                                                    Purchases
                                                    <ReportSortArrows field="conversions" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("conversionRate", e)}>
                                                <div className="sortable-header-inner">
                                                    Conversion Rate
                                                    <ReportSortArrows field="conversionRate" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                            <th className="sortable-header" style={{ cursor: "pointer" }} onClick={(e) => handleSort("revenue", e)}>
                                                <div className="sortable-header-inner">
                                                    Revenue
                                                    <ReportSortArrows field="revenue" activeSortField={sortField} sortOrder={sortOrder} onSort={setSort} />
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length === 0 ? (
                                            <tr>
                                                <td colSpan={7}>
                                                    <div className="emptyPlaceholder">
                                                        <div>
                                                            <div>
                                                                <img src={require("./../../../../assets/images/paper-plane-grey.png")} className='img-fluid' alt="No data found" />
                                                            </div>
                                                            <div className="rsInfoMsg disabled">
                                                                <div className="flex-1">No records found.</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            data.map((row, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div className='d-flex align-items-center'>
                                                            <img
                                                                src={row.productImage}
                                                                alt={row.productName}
                                                                width="35"
                                                                height="35"
                                                                style={{
                                                                    objectFit: "cover",
                                                                    marginRight: "8px",
                                                                    borderRadius: "4px"
                                                                }}
                                                            />
                                                            <span>{row.productName}</span>
                                                        </div>
                                                    </td>
                                                    <td>{row.impressions?.toLocaleString() || 0}</td>
                                                    <td>{row.clicks?.toLocaleString() || 0}</td>
                                                    <td>{row.ctr}</td>
                                                    <td>{row.conversions?.toLocaleString() || 0}</td>
                                                    <td>{row.conversionRate}</td>
                                                    <td>${typeof row.revenue === 'number' ? row.revenue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) : row.revenue}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </Table>
                            }
                            {totalPageCount > 1 &&
                                <div className='d-flex justify-content-center mt-5'>
                                    <ReactPaginate
                                        nextLabel=">"
                                        onPageChange={(event) => setPage(event.selected)}
                                        page={page}
                                        pageRangeDisplayed={3}
                                        marginPagesDisplayed={2}
                                        pageCount={totalPageCount}
                                        previousLabel="<"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="page-item"
                                        nextLinkClassName="page-link"
                                        breakLabel="..."
                                        breakClassName="page-item"
                                        breakLinkClassName="page-link"
                                        containerClassName="pagination"
                                        activeClassName="active"
                                        renderOnZeroPageCount={null}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

export default TopPerformingProducts;

